import type { RouteObject } from 'react-router-dom'
import { AppShell } from './AppShell'
import { HomePage } from '../pages/HomePage'
import { CatalogPage } from '../pages/CatalogPage'
import { CategoriesPage } from '../pages/CategoriesPage'
import { ProductPage } from '../pages/ProductPage'
import { ProductStoresPage } from '../pages/ProductStoresPage'
import { CartPage } from '../pages/CartPage'
import { CheckoutPage } from '../pages/CheckoutPage'
import { CheckoutAddressPage } from '../pages/CheckoutAddressPage'
import { CheckoutPharmacyPage } from '../pages/CheckoutPharmacyPage'
import { PrivacyPolicyPage } from '../pages/PrivacyPolicyPage'
import { CheckoutSuccessPage } from '../pages/CheckoutSuccessPage'
import { OrdersPage } from '../pages/OrdersPage'
import { OrderPage } from '../pages/OrderPage'
import { ProfilePage } from '../pages/ProfilePage'
import { ProfileEditPage } from '../pages/ProfileEditPage'
import { ProfilePhonePage } from '../pages/ProfilePhonePage'
import { ProfileAddressesPage } from '../pages/ProfileAddressesPage'
import { ProfileAddressEditPage } from '../pages/ProfileAddressEditPage'
import { ProfileCardsPage } from '../pages/ProfileCardsPage'
import { StoresPage } from '../pages/StoresPage'
import { NotificationsPage } from '../pages/NotificationsPage'
import { LoginPage } from '../pages/LoginPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { NewsListPage } from '../pages/NewsListPage'
import { NewsPage } from '../pages/NewsPage'
import { FavoritesPage } from '../pages/FavoritesPage'
import { MultiSearchPage } from '../pages/MultiSearchPage'
import { MultiSearchStoresPage } from '../pages/MultiSearchStoresPage'
import { env } from '../config/env'

/**
 * Экраны за флагами новых функций (`env.features`). Без флага их адресов нет
 * вовсе: такой адрес достаётся обычной странице «не найдено».
 */
function flaggedRoutes(): RouteObject[] {
  return [
    ...(env.features.news
      ? [
          { path: 'news', element: <NewsListPage /> },
          { path: 'news/:newsId', element: <NewsPage /> },
        ]
      : []),
    ...(env.features.favorites ? [{ path: 'favorites', element: <FavoritesPage /> }] : []),
    ...(env.features.multiSearch
      ? [
          { path: 'search', element: <MultiSearchPage /> },
          { path: 'search/stores', element: <MultiSearchStoresPage /> },
        ]
      : []),
  ]
}

/**
 * Экраны прототипа (docs/ui/index.html) в нашей структуре. Вход живёт вне
 * каркаса: во время входа вкладки не нужны. Список собирается по флагам в
 * момент вызова: приложение зовёт его один раз, тест — с флагами, которые
 * включил сам.
 */
export const appRoutes = (): RouteObject[] => [
  { path: '/login', element: <LoginPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  {
    element: <AppShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'catalog', element: <CatalogPage /> },
      { path: 'catalog/:productId', element: <ProductPage /> },
      { path: 'catalog/:productId/stores', element: <ProductStoresPage /> },
      { path: 'categories', element: <CategoriesPage /> },
      { path: 'cart', element: <CartPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
      { path: 'checkout/address', element: <CheckoutAddressPage /> },
      { path: 'checkout/pharmacy', element: <CheckoutPharmacyPage /> },
      { path: 'checkout/success', element: <CheckoutSuccessPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/:orderId', element: <OrderPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'profile/edit', element: <ProfileEditPage /> },
      { path: 'profile/phone', element: <ProfilePhonePage /> },
      { path: 'profile/addresses', element: <ProfileAddressesPage /> },
      { path: 'profile/addresses/:addressId', element: <ProfileAddressEditPage /> },
      { path: 'profile/cards', element: <ProfileCardsPage /> },
      { path: 'stores', element: <StoresPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      ...flaggedRoutes(),
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
